import React from 'react';

const Rating = ({ value }) => {

  let result = [];

  for (let i = 1; i <= value; i++) {
    result.push(<i key={'star' + i} className='fa fa-star selectedStar' />);
  }

  for (let i = value + 1; i <= 4; i++) {
    result.push(<i key={'star' + i} className='fa fa-star notSelectedStar' />);
  }

  return (
    <div data-testid={`rating-${value}`} className='rating'> 
      { result }
    </div>
  );
}

export default Rating;
